'use client'

import { Button } from '@qr-front/ui/components/Button'
import { useAtom, useSetAtom } from 'jotai'
import { useEffect, useState } from 'react'

import {
	DownloadQrDialog,
	downloadQrDialogAtom,
	qrCodeAtom,
	qrDownloadCompletedAtom,
	qrDownloadSuccessDialogAtom,
} from '@/generator/client'
import { qrCodesApi } from '@/generator/shared'

import { QrDownloadSuccessDialog } from './QrDownloadSuccessDialog'

interface DownloadButtonWithModalProps {
	uri: string
	downloadText: string
}

export const DownloadButtonWithModal = ({
	uri,
	downloadText,
}: DownloadButtonWithModalProps) => {
	const setDownloadDialogOpen = useSetAtom(downloadQrDialogAtom)
	const setQrCode = useSetAtom(qrCodeAtom)
	const setSuccessDialogOpen = useSetAtom(qrDownloadSuccessDialogAtom)
	const [downloadCompleted, setDownloadCompleted] = useAtom(
		qrDownloadCompletedAtom,
	)
	const [isLoading, setIsLoading] = useState(false)

	const handleDownload = async () => {
		if (isLoading) return

		setIsLoading(true)
		try {
			const { data: qrCode } = await qrCodesApi.getQrByUri(uri)
			setQrCode(qrCode)
			setDownloadDialogOpen(true)
		} catch (e) {
			console.error(e)
		} finally {
			setIsLoading(false)
		}
	}

	useEffect(() => {
		if (downloadCompleted) {
			setSuccessDialogOpen(true)
			setDownloadCompleted(false)
		}
	}, [downloadCompleted, setSuccessDialogOpen, setDownloadCompleted])

	return (
		<>
			<Button
				visual="default"
				size="large"
				className="w-full"
				onClick={handleDownload}
			>
				{downloadText}
			</Button>
			<DownloadQrDialog />
			<QrDownloadSuccessDialog />
		</>
	)
}
